import { FormSelectYesNo } from '../../formelements'

export const AuthDretsImatge = ({ auth, handleChange, error, enguany, anyVinent }) => {
  return (<>
   <div className="row">
     <div className="col col-12 ">
       <h4>
          Autorització als alumnes menors de 14: Drets d’imatge. Curs {enguany}-{anyVinent}
       </h4>
       <p>
       El pare, mare, tutor/a legal o alumne/a menor de 14 anys autoritza que l'alumne/a pugui aparèixer en imatges i/o vídeos, 
       es publiqui el seu nom, així com material elaborat per l'alumne/a corresponents a activitats escolars lectives, complementàries 
       i extraescolars organitzades pel centre, i publicades a la pàgina web del centre, o revistes, o publicacions editades pel 
       centre, així com les seves xarxes socials.
       </p>
     </div>
   </div>

   <div className="row">
     <div className="col col-12 ">
       <FormSelectYesNo
         id="authDretsImatge"
         name="authDretsImatge"
         col="col-4"
         label="Drets d'Imatge:"
         obligatori={true}
         value={auth}
         handleChange={(e) => handleChange(e.target.value) }
         error={error}
       />
   </div>
  </div>

    <br />
  </>)
}
